var React = require('react');

function HeadSide (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M509.21 275c-20.94-47.12-48.44-151.73-73.08-186.75A208 208 0 0 0 266.09 0H192C86 0 0 86 0 192a191.28 191.28 0 0 0 64 142.82V512h256v-64h64a64 64 0 0 0 64-64v-64h32a32 32 0 0 0 29.21-45zM320 224a32 32 0 1 1 32-32 32 32 0 0 1-32 32z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M320 224a32 32 0 1 1 32-32 32 32 0 0 1-32 32z","className":"fa-primary","key":2})]);
}

HeadSide.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = HeadSide;

HeadSide.default = HeadSide;
